import chromeCoilMidiSourceUrl from "../assets/chrome-coil.mid?url&no-inline";
import chromeCoilMp3Url from "../assets/chrome-coil.mp3?url&no-inline";
import crownOfSparksMidiSourceUrl from "../assets/crown-of-sparks.mid?url&no-inline";
import crownOfSparksMp3Url from "../assets/crown-of-sparks.mp3?url&no-inline";
import meteorcoilMidiSourceUrl from "../assets/meteorcoil.mid?url&no-inline";
import meteorcoilMp3Url from "../assets/meteorcoil.mp3?url&no-inline";
import sidewinderStompMidiSourceUrl from "../assets/sidewinder-stomp.mid?url&no-inline";
import sidewinderStompMp3Url from "../assets/sidewinder-stomp.mp3?url&no-inline";
import {
  selectedSoundtrackConfigs,
  type SelectedSoundtrackId,
} from "../config/soundtrack-config";

interface SelectedSoundtrack {
  readonly id: SelectedSoundtrackId;
  readonly midiSourceUrl: string;
  readonly mp3Url: string;
  readonly name: string;
  readonly playbackGain: number;
}

export const selectedSoundtracks = {
  "chrome-coil": {
    ...selectedSoundtrackConfigs["chrome-coil"],
    midiSourceUrl: chromeCoilMidiSourceUrl,
    mp3Url: chromeCoilMp3Url,
  },
  meteorcoil: {
    ...selectedSoundtrackConfigs.meteorcoil,
    midiSourceUrl: meteorcoilMidiSourceUrl,
    mp3Url: meteorcoilMp3Url,
  },
  "sidewinder-stomp": {
    ...selectedSoundtrackConfigs["sidewinder-stomp"],
    midiSourceUrl: sidewinderStompMidiSourceUrl,
    mp3Url: sidewinderStompMp3Url,
  },
  "crown-of-sparks": {
    ...selectedSoundtrackConfigs["crown-of-sparks"],
    midiSourceUrl: crownOfSparksMidiSourceUrl,
    mp3Url: crownOfSparksMp3Url,
  },
} as const satisfies Readonly<Record<SelectedSoundtrackId, SelectedSoundtrack>>;
